document.addEventListener("DOMContentLoaded", function () {
  let travelModalOpen = false

  document.querySelectorAll(".js--swap").forEach((element) => {
    element.addEventListener("click", function () {
      slayData("destination inline", "show - edit")
    })
  })

  window.addEventListener("modal:render", function (e) {
    const elm = e.detail.modal.el
    const isTravelModal = elm.classList.contains("modal--travelinfo-modal")
    if (isTravelModal) {
      travelModalOpen = true
      slayData("destination modal", "show - auto")

      document.querySelectorAll(".link.js--close-modal").forEach((element) => {
        element.addEventListener("click", function (e) {
          travelModalOpen = false
          modalCancel()
          e.target.removeEventListener("click")
        })
      })
    }
  })

  window.addEventListener("modal:close", function () {
    if (travelModalOpen === true) {
      modalClosed()
    }
  })

  function modalClosed() {
    setTimeout(function () {
      if (travelModalOpen === true) {
        travelModalOpen = false
        slayData("destination modal", "close")
      }
    }, 20)
  }

  function modalCancel() {
    slayData("destination modal", "later")
  }

  window.addEventListener("basket:destination:render", function () {
    slayData("destination inline", "show - auto")
  })

  window.addEventListener("destination:updated", function (e) {
    const el = e.detail

    const gaObject = {}

    if (el.isEu !== null) {
      gaObject["userDestinationEu"] = el.isEu
    }

    if (el.country) {
      gaObject["userDestinationCountry"] = el.country
    }

    if (el.city) {
      gaObject["userDestinationCity"] = el.city
    }

    slayData("destination " + el.type, "submit", gaObject)
  })

  function slayData(action, label, extraData) {
    window.dataLayer = window.dataLayer || []
    let gmObj = {
      event: "track-event",
      eventCategory: "ecommerce",
      eventAction: action,
      eventLabel: label,
      eventValue: 0,
      eventNoninteraction: true,
    }

    if (extraData) {
      gmObj = { ...gmObj, ...extraData }
    }
    window.dataLayer.push(gmObj)
  }
})

export const gtmProductClick = function (event) {
  if (window["google_tag_manager"]) {
    event.preventDefault()
    const element = event.target.closest(".product-tile.js--product-tile")
    const targetUrl = element.dataset.url
    const gtmObj = {
      ecommerce: {
        currencyCode: element.dataset.currencycode,
        click: {
          actionField: { list: element.dataset.list.toLowerCase() },
          products: [
            {
              id: element.dataset.productId.toLowerCase(),
              name: element.dataset.name.toLowerCase(),
              price: element.dataset.price,
              category: element.dataset.category,
              brand: element.dataset.brand.toLowerCase(),
              variant: element.dataset.variant.toLowerCase(),
              position: element.dataset.position,
            },
          ],
        },
      },
      event: "productClick",
      eventCallback: function () {
        document.location = targetUrl
      },
      eventTimeout: 2000,
    }
    window.dataLayer.push(gtmObj)
  }
}
